export default __webpack_public_path__ + "static/media/logols3.14ed8d06.png";